import React from 'react';
import PropTypes from 'prop-types';
import { getTablePartController, getTPCommandPanel } from '../../../../BaseEditor';
import { GridTemplate } from './styles';
import BodyComponent from './body';
import HeaderComponent from './header';
import { StyledButton, StyledImg, StyledText } from '../../../../../components/Styled/Buttons/styledCommandPanelButton';
import { DraftIcon } from '../../../../../components/Styled/Buttons/icons';

function ChangeView({ setTypeView, typeView }) {
  return (
    <StyledButton
      title="Режим перегляду"
      onClick={() => {
        setTypeView(!typeView);
      }}
    >
      <StyledImg src={DraftIcon} alt="Режим перегляду" />
      <StyledText>Режим перегляду</StyledText>
    </StyledButton>
  );
}

ChangeView.propTypes = {
  setTypeView: PropTypes.func,
  typeView: PropTypes.bool,
};

ChangeView.defaultProps = {
  setTypeView: () => null,
  typeView: true,
};

const CommandPanel = getTPCommandPanel(ChangeView);

const newRecordData = () => ({
  account: { id: null, repr: '' },
  account_id: null,
  contract: { id: null, repr: '' },
  contract_id: null,
  id: null,
  order_amount: '',
  payer: { id: null, full_name: '' },
  payer_id: null,
  payment_date: null,
  payment_notes: null,
  payment_number: '',
  revenue_amount: null,
  warning: false,
});

export default getTablePartController(
  GridTemplate,
  BodyComponent,
  newRecordData,
  CommandPanel,
  HeaderComponent,
);
